import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';

export default function quickAccessDocumentReducer(state = initialstate.quickAccessDocument, action) {
	switch (action.type) {
		case types.GET_QUICK_ACCESS_DOCUMENT:
			if (action.response) {
				let propertyArray = Object.keys(action.response);
				let quickAccess = false;
				quickAccess = propertyArray.some((property) => !_.isEmpty(action.response[property]));
				return quickAccess;
			} else {
				return state;
			}
		default:
			return state;
	}
}
